import React, { useEffect, useState } from "react";

const Footer = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    fetch("/data/footerLinks.json") // Load from public folder
      .then((res) => res.json())
      .then((data) => setLinks(data))
      .catch((err) => console.error("Failed to load footer links:", err));
  }, []);

  return (
    <footer className="bg-gray-800 text-white py-6 border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-6 text-center">
      <p>&copy; {new Date().getFullYear()} {"ZT();"} &mdash; All rights reserved.</p>
        <div className="mt-4 space-x-4">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xl hover:text-gray-400"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
